import { render, staticRenderFns } from "./ComplianceDocumentsPage.vue?vue&type=template&id=254841d2&scoped=true"
import script from "./ComplianceDocumentsPage.vue?vue&type=script&lang=js"
export * from "./ComplianceDocumentsPage.vue?vue&type=script&lang=js"
import style0 from "./ComplianceDocumentsPage.vue?vue&type=style&index=0&id=254841d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254841d2",
  null
  
)

export default component.exports